import { useCallback } from 'react'
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react'
import { isProduction, isSandbox, isTest } from 'utils/environment'

type Flow = 'LOGIN'
interface TrackFingerprintProps {
  flow?: Flow
  merchantName: string
  accountId: number
  accountReference: string
  profileId: number
}

export const useFingerprint = () => {
  const { getData, isLoading, error, data } = useVisitorData(
    { extendedResult: true },
    { immediate: false }
  )

  const trackFingerprint = useCallback(
    ({
      merchantName,
      accountId,
      accountReference,
      profileId,
      flow = 'LOGIN',
    }: TrackFingerprintProps) => {
      const enableFingerprint = !!flow && !!merchantName && !!accountId && !!profileId

      if (!enableFingerprint || !(isSandbox || isProduction || isTest)) return

      return getData({
        tag: {
          source: 'BVNK Merchant Portal',
          flow,
          merchantName,
          accountId,
          accountReference,
        },
      })
    },
    [getData]
  )

  return { trackFingerprint, isLoading, error, data }
}
